import { render, staticRenderFns } from "./BigQuestionOverview.vue?vue&type=template&id=16e98eac&scoped=true&"
import script from "./BigQuestionOverview.vue?vue&type=script&lang=js&"
export * from "./BigQuestionOverview.vue?vue&type=script&lang=js&"
import style0 from "./BigQuestionOverview.vue?vue&type=style&index=0&id=16e98eac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e98eac",
  null
  
)

export default component.exports